import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import skillsReducer from './reducers/skillsReducer';
import leadReducer from './reducers/leadReducer';
import planReducer from './reducers/planReducer';

export default combineReducers({
  routing: routerReducer,
  skillsReducer,
  leadReducer,
  planReducer,
});
